import * as React from 'react';

import { Box, useTheme, Card, Button } from '@botco/library';
import { AddIcon } from '@botco/library/icons';

import { CreateAgentModal } from '../CreateAgentModal';

interface PropsType {
  className?: string;
}

export const AgentsListCreateCard = ({ className }: PropsType) => {
  const theme = useTheme();

  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <>
      <Card height={250} className={className}>
        <AddIcon
          sx={{
            fontSize: '72px',
            margin: '20px 0',
            color: theme.palette.primary.main,
          }}
        />
        <Box display="flex" flexDirection="column" gap={1}>
          <Button
            fullWidth
            variant="outlined"
            onClick={handleOpenModal}
            data-testid="create-new-agent-button"
          >
            CREATE NEW
          </Button>
        </Box>
      </Card>
      {isModalOpen && (
        <CreateAgentModal modalOpen={isModalOpen} closed={handleCloseModal} />
      )}
    </>
  );
};
